export default {
  none: [{ value: "none", label: "Selecionar" }],
  "00": [
    { value: "none", label: "Selecionar" },
    { value: "5101", label: "5.101 - Venda de produção do estabelecimento." },
    {
      value: "5102",
      label: "5.102 - Venda de mercadoria adquirida ou recebida de terceiros."
    },
    {
      value: "5103",
      label:
        "5.103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento."
    },
    {
      value: "5104",
      label:
        "5.104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento."
    },
    {
      value: "5115",
      label:
        "5.115 - Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil."
    }
  ],
  10: [
    { value: "none", label: "Selecionar" },
    { value: "5101", label: "5.101 - Venda de produção do estabelecimento." },
    {
      value: "5102",
      label: "5.102 - Venda de mercadoria adquirida ou recebida de terceiros."
    },
    {
      value: "5103",
      label:
        "5.103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento."
    },
    {
      value: "5104",
      label:
        "5.104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento."
    },
    {
      value: "5115",
      label:
        "5.115 - Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil."
    }
  ],
  20: [
    { value: "none", label: "Selecionar" },
    { value: "5101", label: "5.101 - Venda de produção do estabelecimento." },
    {
      value: "5102",
      label: "5.102 - Venda de mercadoria adquirida ou recebida de terceiros."
    },
    {
      value: "5103",
      label:
        "5.103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento."
    },
    {
      value: "5104",
      label:
        "5.104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento."
    },
    {
      value: "5115",
      label:
        "5.115 - Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil."
    }
  ],
  30: [
    { value: "none", label: "Selecionar" },
    { value: "5101", label: "5.101 - Venda de produção do estabelecimento." },
    {
      value: "5102",
      label: "5.102 - Venda de mercadoria adquirida ou recebida de terceiros."
    },
    {
      value: "5103",
      label:
        "5.103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento."
    },
    {
      value: "5104",
      label:
        "5.104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento."
    },
    {
      value: "5115",
      label:
        "5.115 - Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil."
    }
  ],
  40: [
    { value: "none", label: "Selecionar" },
    { value: "5101", label: "5.101 - Venda de produção do estabelecimento." },
    {
      value: "5102",
      label: "5.102 - Venda de mercadoria adquirida ou recebida de terceiros."
    },
    {
      value: "5103",
      label:
        "5.103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento."
    },
    {
      value: "5104",
      label:
        "5.104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento."
    },
    {
      value: "5115",
      label:
        "5.115 - Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil."
    }
  ],
  41: [
    { value: "none", label: "Selecionar" },
    { value: "5101", label: "5.101 - Venda de produção do estabelecimento." },
    {
      value: "5102",
      label: "5.102 - Venda de mercadoria adquirida ou recebida de terceiros."
    },
    {
      value: "5103",
      label:
        "5.103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento."
    },
    {
      value: "5104",
      label:
        "5.104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento."
    },
    {
      value: "5115",
      label:
        "5.115 - Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil."
    }
  ],
  50: [
    { value: "none", label: "Selecionar" },
    { value: "5101", label: "5.101 - Venda de produção do estabelecimento." },
    {
      value: "5102",
      label: "5.102 - Venda de mercadoria adquirida ou recebida de terceiros."
    },
    {
      value: "5103",
      label:
        "5.103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento."
    },
    {
      value: "5104",
      label:
        "5.104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento."
    },
    {
      value: "5115",
      label:
        "5.115 - Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil."
    }
  ],
  60: [
    { value: "none", label: "Selecionar" },
    {
      value: "5405",
      label: "5.405 - Venda de mercadoria adquirida ou recebida de terceiros."
    },
    {
      value: "5656",
      label:
        "5.656 - Venda de combustível ou lubrificante adquirido ou recebido de terceiros destinado a consumidor ou usuário final."
    },
    {
      value: "5667",
      label:
        "5.667 - Venda de combustível ou lubrificante a consumidor ou usuário final estabelecido em outra Unidade da Federação."
    }
  ],
  90: [
    { value: "none", label: "Selecionar" },
    { value: "5101", label: "5.101 - Venda de produção do estabelecimento." },
    {
      value: "5102",
      label: "5.102 - Venda de mercadoria adquirida ou recebida de terceiros."
    },
    {
      value: "5103",
      label:
        "5.103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento."
    },
    {
      value: "5104",
      label:
        "5.104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento."
    },
    {
      value: "5115",
      label:
        "5.115 - Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil."
    }
  ],
  102: [
    { value: "none", label: "Selecionar" },
    { value: "5101", label: "5.101 - Venda de produção do estabelecimento." },
    {
      value: "5102",
      label: "5.102 - Venda de mercadoria adquirida ou recebida de terceiros."
    },
    {
      value: "5103",
      label:
        "5.103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento."
    },
    {
      value: "5104",
      label:
        "5.104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento."
    },
    {
      value: "5115",
      label:
        "5.115 - Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil."
    }
  ],
  300: [
    { value: "none", label: "Selecionar" },
    { value: "5101", label: "5.101 - Venda de produção do estabelecimento." },
    {
      value: "5102",
      label: "5.102 - Venda de mercadoria adquirida ou recebida de terceiros."
    },
    {
      value: "5103",
      label:
        "5.103 - Venda de produção do estabelecimento, efetuada fora do estabelecimento."
    },
    {
      value: "5104",
      label:
        "5.104 - Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento."
    },
    {
      value: "5115",
      label:
        "5.115 - Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil."
    }
  ],
  500: [
    { value: "none", label: "Selecionar" },
    {
      value: "5405",
      label: "5.405 - Venda de mercadoria adquirida ou recebida de terceiros..."
    },
    {
      value: "5656",
      label:
        "5.656 - Venda de combustível ou lubrificante adquirido ou recebido de terceiros..."
    },
    {
      value: "5667",
      label:
        "5.667 - Venda de combustivel ou lubrificante a consumidor ou usuário final estabelecido em outra unidade de federação..."
    }
  ]
};



// WEBPACK FOOTER //
// ./src/core/enum/cfop-values.enum.js